import React from 'react';

const AppleIAP = () => (
  <h3>IAP by Apple</h3>
);

export default AppleIAP;
